import {Component, Renderer2, AfterViewInit, OnInit, ChangeDetectorRef, ViewChild, ElementRef, OnDestroy, Input} from "@angular/core";
import {Order, SimpleOrderTotal} from "../../../../../objects/orders/order";
import {ActivatedRoute, Router} from "@angular/router";
import {CanadianCurrencyCode} from "../../../../../objects/currencyExchange/canadianCurrencyCode";
import { FormControl, NgForm, Validators, FormGroup } from "@angular/forms";
import {PaymentService} from "../../../../../services/paymentService";
import {CustomerService} from "../../../../../services/customerService";
import {EmailTemplateType} from "../../../../../objects/email/emailTemplateType";
import {EmailService} from "../../../../../services/emailService";
import {ConfigService} from "../../../../../services/configService";
import { PaymentEmailRequest } from "../../../../../objects/email/PaymentEmailRequest";
import { reject } from "lodash";
import { ScrollHelper } from "../../../../../common/helpers/scrollHelper";
import { Address, AddressComponent } from "ng2-google-place-autocomplete/src/app/ng2-google-place.classes";
import { CountryWithStates } from "../../../../../objects/management/locationManagement/countryWithStates";
import { LocationService } from "../../../../../services/locationService";
import { CountryState } from "../../../../../objects/management/locationManagement/countryState";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs/Subject";
import { PaymentCompany } from "../../../../../objects/payment/paymentCompany";

declare var Stripe: any;
declare var google: any;

@Component({
    selector: "order-payment",
    templateUrl: "./order-payment.component.html",
    styleUrls: ['../../../../../../theme/css/order-payment.css'],
    moduleId: module.id.toString()
})

export class OrderPaymentComponent implements AfterViewInit, OnInit, OnDestroy{

    public order: Order = new Order();
    public currency: string;
    public grandTotalPayable: number;
    public addressOneSearchBox: any;
    public addressLineOneInput: any;

    @ViewChild('cardInfo') cardInfo: ElementRef;

    public card: any;
    public cardHandler = this.onChange.bind(this);
    public error: string;

    public showCustomerData: boolean;
    public showNextStep: boolean = false;
    public isHaveBeenPayed: boolean = false;
    public showLoader: boolean = false;
    public showPayPalLoader: boolean = false;
    public payPalRequestFailed: boolean = false;
    public isSecondTry: boolean = false;

    public get firstName() { return this.checkoutForm.get('firstName'); }
    public get lastName() { return this.checkoutForm.get('lastName'); }
    public get company() { return this.checkoutForm.get('company'); }
    public get addressLineOne() { return this.checkoutForm.get('addressLineOne'); }
    public get addressLineTwo() { return this.checkoutForm.get('addressLineTwo'); }
    public get city() { return this.checkoutForm.get('city'); }
    public get state() { return this.checkoutForm.get('state'); }
    public get country() { return this.checkoutForm.get('country'); }
    public get phoneNumber() { return this.checkoutForm.get('phone'); }

    public cargoWiseOrganizationCode: string;
    public pipedriveId: string;
    public pipedriveDealId: string;
    public name: string;
    public email: string;
    public phone: string;
    public amount: string;
    public currencyCode: string;
    public fileNumber: string;
    public customMessage: string;
    public userId: number;
    public agentUserId: number;
    public agentUserEmail: string;
    public isPayPal: boolean;
    public payPalRequestIsSent: boolean;
    public paymentCompany: PaymentCompany;

    public stripe: any;
    public elements: any;
    public checkoutForm: FormGroup;
    
    public countryStates: CountryWithStates[];
    public currentStates: CountryState[];
    public countrySelectData: string[];
    public stateSelectData$: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
    public cancelableSubject$: Subject<boolean> = new Subject<boolean>();
    public validationError: string;

    constructor(private renderer: Renderer2,
                private route: ActivatedRoute,
                private cdr: ChangeDetectorRef,
                private configService: ConfigService,
                private paymentService: PaymentService,
                private customService: CustomerService,
                private emailService: EmailService,
                private locationService: LocationService) {

        this.paymentCompany = this.route.snapshot.queryParams['paycom'];
        let key = this.configService.config.CanadaStripeKey;
        if(this.paymentCompany == PaymentCompany.NexGen)
            key = this.configService.config.USAStripeKey;
        this.stripe = Stripe(key);
        this.elements = this.stripe.elements();

        this.order.Currency = new CanadianCurrencyCode();
        this.order.Totals = new SimpleOrderTotal();
    }

    ngOnInit(): void {
        let email = this.route.snapshot.queryParams['email'];
        this.userId = this.route.snapshot.queryParams['c'];

        this.showCustomerData = this.userId == 0;
        let emailTypeParam = this.route.snapshot.queryParams['emailtype'];
        this.amount = this.route.snapshot.queryParams['am'];
        this.currencyCode = this.route.snapshot.queryParams['ccode'];
        this.fileNumber = this.route.snapshot.queryParams['fn'];
        this.agentUserId = this.route.snapshot.queryParams['an'];
        this.agentUserEmail = this.route.snapshot.queryParams['ane'];
        this.isPayPal = this.route.snapshot.queryParams['pp'] == "1";
        this.cargoWiseOrganizationCode = this.route.snapshot.queryParams['cwoc'];
        this.pipedriveId = this.route.snapshot.queryParams['pipedriveid'];
        this.pipedriveDealId = this.route.snapshot.queryParams['pipedrivedealid'];

        this.isSecondTry = emailTypeParam == EmailTemplateType.CreditCardDontWork;

        this.checkoutForm = new FormGroup({
            firstName: new FormControl(undefined, [ Validators.required ]),
            lastName: new FormControl(undefined, [ Validators.required ]),
            company: new FormControl(undefined, [ Validators.maxLength(49) ]),
            phone: new FormControl(undefined, [ Validators.required ]),
            addressLineOne: new FormControl(undefined, [ Validators.required ]),
            addressLineTwo: new FormControl(),
            city: new FormControl(),
            state: new FormControl(),
            country: new FormControl()
        });

        this.customService.getCustomerPayDataById(this.userId).then(resp => {
            if (resp.Success) {
                this.firstName.setValue(resp.Data.FirstName, resp.Data.LastName);
                this.lastName.setValue( resp.Data.LastName);
                this.company.setValue(resp.Data.CompanyName);
                this.addressLineOne.setValue(resp.Data.AddressLine1);
                this.addressLineTwo.setValue(resp.Data.AddressLine2);
                this.city.setValue(resp.Data.City);
                this.state.setValue(resp.Data.State);
                this.country.setValue(resp.Data.Country);
                this.phoneNumber.setValue(resp.Data.Phone);

                this.name = this.getFullName(resp.Data.FirstName, resp.Data.LastName);
                this.email = resp.Data.Email;
                this.cdr.detectChanges();
            }
        }, reason => {
            console.log(reason);
        })
    }

    initGApi() {
      const baseScriptUrl = `https://maps.googleapis.com/maps/api/js?key=${this.configService.config.GoogleApiKey}`;
      const head = document.getElementsByTagName('head')[0];
  
      const scripts = document.getElementsByTagName('script');
  
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < scripts.length; i++) {
        if (scripts[i].src.startsWith(baseScriptUrl)) {
          this.initSearchBox();
          return;
        }
      }
  
      const node: any = document.createElement('script');
      node.src = `${baseScriptUrl}&libraries=places&language=en`;
      node.type = 'text/javascript';
      node.charset = 'utf-8';
  
      head.appendChild(node);
  
      node.onload = () => {
        this.initSearchBox();
      };
    }

    initSearchBox(){
        this.addressLineOneInput = document.getElementById('pac-input');
        this.addressOneSearchBox = new google.maps.places.SearchBox(this.addressLineOneInput);
        this.addressOneSearchBox.addListener('places_changed', () =>{
            this.fillPlaces();
            this.validationError = null;
        });
    }

    fillPlaces(){
        const places = this.addressOneSearchBox.getPlaces();

        if (places.length == 0) {
            return;
        }

        let locality, administrative_area_level_1, administrative_area_level_2, country: string;
        let place: Address = places[0];
        place.address_components.forEach((component: AddressComponent) => {
            if (component.types.indexOf("locality") > -1) {
                locality = component.short_name;
            } else if (component.types.indexOf("administrative_area_level_1") > -1) {
                administrative_area_level_1 = component.short_name;
            } else if (component.types.indexOf("administrative_area_level_2") > -1) {
                administrative_area_level_2 = component.short_name;
            } else if (component.types.indexOf("country") > -1) {
                country = component.short_name;
            } 
        });

        this.city.setValue(locality);
        
        this.country.setValue(null);
        this.state.setValue(null);
        this.currentStates = [];
        
        const matchingCountry = this.countryStates.find(x => x.Code == country || x.Name == country);
        if (matchingCountry){
            this.country.setValue(matchingCountry.Name);
            this.currentStates = this.countryStates.find(x => x.Name == matchingCountry.Name).States;
        }
        
        this.updateStateSelectData();

        const state = administrative_area_level_1 || administrative_area_level_2;
        const matchingState = this.currentStates.find(x => x.Code == state || x.Description == state);
        if (matchingState){
            this.state.setValue(matchingState.Description);
        }
        
        if (this.addressLineOneInput){
            let addressInputValue: string = this.addressLineOneInput.value;

            if (matchingCountry) {
                addressInputValue = addressInputValue.replace(`, ${matchingCountry.Code}`, '')
                                                     .replace(`, ${matchingCountry.Name}`, '');
            }

            if (matchingState) {
                addressInputValue = addressInputValue.replace(`, ${matchingState.Code}`, '')
                                                     .replace(`, ${matchingState.Description}`, '');
            }
            
            if (this.city.value){
                addressInputValue = addressInputValue.replace(`, ${this.city.value}`, '');
            }

            this.addressLineOne.setValue(addressInputValue);
        }
    }

    getFullName(FirstName :string, LastName: string): string{
        const fullName = FirstName && LastName ? `${FirstName} ${LastName}` : FirstName ? FirstName : "";
        return fullName;
    }

    async ngAfterViewInit() {
        let spinner = document.getElementById("spinner");
        this.renderer.addClass(spinner, "hide");
        
        ScrollHelper.forceSetVerticalScroll(document.getElementsByTagName('body')[0]);

        if (this.isPayPal){
            setTimeout(x=> {
                this.sendPayPalPaymentRequest(this.userId);
            }, 200);
            return;
        }

        this.card = this.elements.create('card');
        this.card.mount(this.cardInfo.nativeElement);

        this.card.addEventListener('change', this.cardHandler);
        
        this.initGApi();

        this.stateSelectData$.pipe(
            takeUntil(this.cancelableSubject$),
            ).subscribe(() => this.cdr.detectChanges());

        let countryStates = (await this.locationService.getCountryStates()).Data;
        let canada = countryStates.find(x => x.Code == 'CA');
        let usa = countryStates.find(x => x.Code == 'US');
        this.countryStates = [ canada, usa, ...countryStates.filter(x => x.Code != 'CA' && x.Code != 'US') ];
        this.countrySelectData = this.countryStates.map(x => x.Name);
        this.country.setValue(null);
        this.state.setValue(null);
    }

    onCountryChange(val: any) {
        this.currentStates = this.countryStates.find(x => x.Name == val).States;
        this.updateStateSelectData();
        this.state.setValue(null);
    }

    updateStateSelectData() {
        if (this.currentStates){
            this.stateSelectData$.next(this.currentStates.map(x => x.Description).sort()); 
        } else {
            this.stateSelectData$.next([]);
        }
    }

    ngOnDestroy() {
        this.cancelableSubject$.next(true);
        this.card.removeEventListener('change', this.cardHandler);
        this.card.destroy();
    }

    onChange(error: any) {
        if (error) {
            this.error = error.message;
        } else {
            this.error = null;
        }
        this.cdr.detectChanges();
    }

    sendPayPalPaymentRequest(customerId: number) {
        this.showPayPalLoader = true;
        this.payPalRequestFailed = false;
        this.emailService.sendPayPalPaymentRequest(customerId).then(resp => {
            this.showPayPalLoader = false;
            this.payPalRequestIsSent = true;
            if(!resp.Success){
                this.payPalRequestFailed = true;
            }
        }).catch(resp => {
            this.showPayPalLoader = false;
            this.payPalRequestIsSent = true;
            this.payPalRequestFailed = true;
        })
    }

    async onSubmit() {
        this.error = null;
        if(!this.checkoutForm.valid){
            this.error = "Please fill in the required fields";
            return;
        }

        if (!this.country.value) {
            this.validationError = "You must select address from dropdown menu in Address field";
            return;
        }

        this.showLoader = true;
        this.stripe.createPaymentMethod({
            type: 'card',
            card: this.card,
            billing_details: { name: `${this.firstName.value} ${this.lastName.value}`, email: this.email, phone: this.phoneNumber.value }
        }).then((result: any) => {
            if (result.error) {
                this.showLoader = false;
                this.error = result.error.message;
            } else {
                const country = this.countryStates.find(i => i.Name.toLowerCase() == this.country.value.toLowerCase());
                const stateCode = this.state.value ? country.States.find(i => i.Description.toLowerCase() == this.state.value.toLowerCase()).Code : '';

                this.paymentService.save({ 
                    paymentMethodId: result.paymentMethod.id,
                    CustomerId: this.userId,
                    PaymentCompany: this.paymentCompany,
                    FirstName: this.firstName.value,
                    LastName: this.lastName.value,
                    CompanyName: this.company.value,
                    AddressLine1: this.addressLineOne.value,
                    AddressLine2: this.addressLineTwo.value,
                    City: this.city.value,
                    State: this.state.value,
                    StateCode: stateCode,
                    PostalCode: result.paymentMethod.billing_details.address.postal_code,
                    Country: this.country.value,
                    CountryCode: country.Code,
                    CargoWiseOrganizationCode: this.cargoWiseOrganizationCode,
                    PipedriveId: this.pipedriveId,
                    PipedriveDealId: this.pipedriveDealId,
                    AgentUserId: this.agentUserId,
                    AgentUserEmail: this.agentUserEmail,
                    Phone: this.phoneNumber.value }).then(responce => {
                    if (this.isSecondTry) {

                        this.paymentService.pay(this.fileNumber, parseFloat(this.amount), this.currencyCode, this.userId, this.agentUserId, this.agentUserEmail, this.paymentCompany).then(resp => {

                            this.isHaveBeenPayed = true;

                        }, rej => {
                            
                            this.error = rej.Data.Message;
                        });
                    }else{
                        this.showNextStep = true;
                    }
                }, reject => {

                    this.showLoader = false;
                    if (reject.Errors && reject.Errors.length > 0) {
                        this.error = reject.Errors[0].Value;
                    } else if (reject.Data && reject.Data.Message) {
                        this.error = reject.Data.Message;
                    } else {
                        this.error = "An error has occured";
                    }

                    this.cdr.detectChanges();
                });
            }
        }, (reject: any) => {

            this.showLoader = false;
            console.log(reject);
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/calculator/public/mobile/order-payment/order-payment.component.ts